import React, { Dispatch, SetStateAction } from 'react'

import { ObservabilityToolAWSAuthenticationDetails } from 'components/status-checks/form/authentication/aws/ObservabilityToolAWSAuthenticationDetails'
import { ObservabilityToolCustomAuthenticationDetails } from 'components/status-checks/form/authentication/ObservabilityToolCustomAuthenticationDetails'
import { ObservabilityToolOtherAuthenticationDetails } from 'components/status-checks/form/authentication/ObservabilityToolOtherAuthenticationDetails'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

export const ObservabilityToolAuthenticationDetails: React.FC<{
  isAuthenticationValid: boolean
  observabilityToolType:
    | ObservabilityToolType.AWS
    | ObservabilityToolType.CUSTOM
    | 'other'
  setIsAuthenticationValid: Dispatch<SetStateAction<boolean>>
}> = ({
  isAuthenticationValid,
  observabilityToolType,
  setIsAuthenticationValid
}) => {
  switch (observabilityToolType) {
    case ObservabilityToolType.CUSTOM:
      return (
        <ObservabilityToolCustomAuthenticationDetails
          isAuthenticationValid={isAuthenticationValid}
          setIsAuthenticationValid={setIsAuthenticationValid}
        />
      )
    case ObservabilityToolType.AWS:
      return (
        <ObservabilityToolAWSAuthenticationDetails
          isAuthenticationValid={isAuthenticationValid}
          setIsAuthenticationValid={setIsAuthenticationValid}
        />
      )
    default:
      return <ObservabilityToolOtherAuthenticationDetails />
  }
}
